import React, { useState, useEffect } from "react";
import CommonForm from "../../../../../../components/commonform/commonForm";
import "./areastyle.css";
import "./style.css";
import TextField from "../../../../../../components/inputs/textfield";
import { userAreaList } from "../../../../user.api";
import Snackbar from "../../../../../../components/snackbar/snackbar";

export default function JointVentureTable(props) {
  const {
    formvalues: incomingFormValues = [],
    handleFormData,
  } = props;

  const [formvalues, setFormValues] = useState([]);
  const [baseArea, setBaseArea] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  useEffect(() => {
    userAreaList().then((res) => {
      setBaseArea(res?.data || []);
    });
  }, []);

  useEffect(() => {
    // Sync with incoming preferences from props
    if (!incomingFormValues || incomingFormValues.length === 0) return;

    const mapped = (incomingFormValues || []).map(item => {
      const category = item.category || item.joint_venture_category || "";
      const built_space_type_name = item.built_space_type_name || item.built_space_type || "";
      const amId = item.area_management_id || (category === "built-up" ? 1 : category === "land" ? 3 : "");

      // Determine available area from baseArea if possible
      let availableArea = item.available_area;
      if (!availableArea && baseArea.length > 0) {
        const match = baseArea.find(a =>
          String(a.location_id) === String(item.location_id) &&
          a.sub_location === item.sub_location &&
          a.area_management_id === Number(amId) &&
          (category !== "built-up" || a.built_space_type?.name === built_space_type_name)
        );
        availableArea = match?.available_area;
      }

      return {
        ...item,
        category: category,
        area_management_id: amId,
        location_id: item.location_id ? String(item.location_id) : "",
        built_space_type_name: built_space_type_name,
        available_area: availableArea || "0",
        investment_model: item.investment_model || "",
        management_plan: item.management_plan || "",
        area_in_sqft: item.area_in_sqft || "",
      };
    });

    if (mapped.length > 0) {
      setFormValues(mapped);
    } else if (formvalues.length === 0) {
      setFormValues([
        {
          category: "",
          area_management_id: "",
          location_id: "",
          sub_location: "",
          built_space_type_name: "",
          area_in_sqft: "",
          available_area: "",
          investment_model: "",
          management_plan: "",
          lease_year: "",
        },
      ]);
    }
  }, [incomingFormValues, baseArea]);


  const handleAdd = () => {
    if (formvalues.length < 3) {
      const updated = [
        ...formvalues,
        {
          category: "",
          area_management_id: "",
          location_id: "",
          sub_location: "",
          built_space_type_name: "",
          area_in_sqft: "",
          available_area: "",
          investment_model: "",
          management_plan: "",
          lease_year: "",
        },
      ];
      setFormValues(updated);
      setTimeout(() => handleFormData(updated), 100);
    }
  };

  const handleRemove = (index) => {
    const updated = formvalues.filter((_, i) => i !== index);
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleLocationChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formvalues];
    const match = baseArea.find((a) => String(a.location_id) === String(value));

    updated[index] = {
      ...updated[index],
      [name]: value,
      sub_location: "",
      built_space_type_name: "",
      available_area: "",
      area_in_sqft: "",
      location: match?.locations?.locations || "",
    };
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleSubLocationChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      [name]: value,
      built_space_type_name: "",
      available_area: "",
      area_in_sqft: "",
    };
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleCategoryChange = (e, index) => {
    const selectedCategory = e.target.value;
    const amId = selectedCategory === "built-up" ? 1 : selectedCategory === "land" ? 3 : "";
    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      category: selectedCategory,
      area_management_id: amId,
      location_id: "",
      sub_location: "",
      built_space_type_name: "",
      available_area: "",
      area_in_sqft: "",
      lease_year: selectedCategory === "land" ? "30" : "",
    };
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleAreaTypeChange = (e, index) => {
    const { value } = e.target;
    const updated = [...formvalues];
    const match = baseArea.find(
      (a) => String(a.location_id) === String(updated[index].location_id) &&
        a.sub_location === updated[index].sub_location &&
        a.built_space_type?.name === value &&
        a.area_management_id === 1
    );

    updated[index] = {
      ...updated[index],
      built_space_type_name: value,
      available_area: match?.available_area || "0",
    };
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleAreaRequirementChange = (e, index) => {
    const { name, value } = e.target;
    if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;

    const updated = [...formvalues];
    let maxArea = 0;
    if (updated[index].category === "built-up") {
      maxArea = parseFloat(updated[index].available_area || 0);
    } else {
      const match = baseArea.find(
        (a) => String(a.location_id) === String(updated[index].location_id) &&
          a.sub_location === updated[index].sub_location &&
          a.area_management_id === 3
      );
      maxArea = parseFloat(match?.available_area || 0);
    }

    const val = parseFloat(value || 0);
    if (val > maxArea) {
      setSnackMessage(`Sorry, we have only ${maxArea} ${updated[index].category === 'built-up' ? 'Sq.ft' : 'Cents'} available at this location.`);
      setIsSnackError(true);
      setSnackOpen(true);
      updated[index][name] = "";
    } else {
      updated[index][name] = value;
    }
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formvalues];
    updated[index] = { ...updated[index], [name]: value };
    setFormValues(updated);
    setTimeout(() => handleFormData(updated), 100);
  };

  const getFilteredLocations = (index) => {
    const item = formvalues[index];
    if (!item.category) return [];

    return Array.from(
      new Map(
        baseArea?.filter(a => a?.locations?.locations && a.area_management_id === item.area_management_id)
          .map((area) => [area?.locations?.locations, area])
      ).values()
    );
  };

  const getSubLocations = (locationId, amId) => {
    return Array.from(new Set(
      baseArea
        .filter((item) => String(item.location_id) === String(locationId) && item.area_management_id === amId)
        .map((item) => item.sub_location)
        .filter(Boolean)
    ));
  };

  const getAreaTypes = (locationId, subLocation) => {
    return Array.from(new Set(
      baseArea
        .filter((a) => String(a.location_id) === String(locationId) && a.sub_location === subLocation && a.area_management_id === 1)
        .map((a) => a.built_space_type?.name)
        .filter(Boolean)
    ));
  };

  return (
    <div className="jointv">
      <div className="mb-3">Select Space as per Priority (Select Maximum 3 Locations)</div>
      {formvalues.map((item, index) => {
        const uniqueLocations = getFilteredLocations(index);
        return (
          <div key={index} className="mb-4 p-3 border rounded shadow-sm bg-white position-relative" style={{ borderLeft: "4px solid #000" }}>
            {formvalues.length > 1 && (
              <button
                type="button"
                aria-label="Remove preference"
                onClick={() => handleRemove(index)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  background: "#000",
                  border: "none",
                  color: "#fff",
                  fontSize: 14,
                  cursor: "pointer",
                  borderRadius: 5,
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >X</button>
            )}
            <div className="fw-bold mb-3 border-bottom pb-2" style={{ color: "#333", fontSize: "1.1rem" }}>Preference {index + 1}</div>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="fieldset">
                  <label className="mb-1">Category</label>
                  <select className="form-select form-control" name="category" value={item.category || ""} onChange={(e) => handleCategoryChange(e, index)} required>
                    <option value="">Select Category</option>
                    <option value="built-up">Built-up Space</option>
                    <option value="land">Land</option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="fieldset">
                  <label className="mb-1">Location</label>
                  <select
                    className="form-select form-control"
                    name="location_id"
                    value={item.location_id || ""}
                    onChange={(e) => handleLocationChange(e, index)}
                    disabled={!item.category}
                    required
                  >
                    <option value="">Select Location</option>
                    {uniqueLocations.map(l => <option key={l.id} value={l.location_id}>{l.locations?.locations}</option>)}
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="fieldset">
                  <label className="mb-1">Sub Location</label>
                  <select
                    className="form-select form-control"
                    name="sub_location"
                    value={item.sub_location || ""}
                    onChange={(e) => handleSubLocationChange(e, index)}
                    disabled={!item.location_id}
                    required
                  >
                    <option value="">Select Sub Location</option>
                    {getSubLocations(item.location_id, item.area_management_id).map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>

              {item.category === "built-up" && (
                <>
                  <div className="col-md-6">
                    <div className="fieldset">
                      <label className="mb-1">Area Type</label>
                      <select
                        className="form-select form-control"
                        name="built_space_type_name"
                        value={item.built_space_type_name || ""}
                        onChange={(e) => handleAreaTypeChange(e, index)}
                        disabled={!item.sub_location}
                        required
                      >
                        <option value="">Select Area Type</option>
                        {getAreaTypes(item.location_id, item.sub_location).map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <TextField label="Total available area (in Sq.ft)" disabled value={item.available_area || ""} />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      label="Area Requirement (in Sq.ft)"
                      name="area_in_sqft"
                      value={item.area_in_sqft || ""}
                      onChange={(e) => handleAreaRequirementChange(e, index)}
                      disabled={!item.built_space_type_name}
                      required
                    />
                  </div>
                </>
              )}

              {item.category === "land" && (
                <>
                  <div className="col-md-6">
                    <TextField label="Total Available Area (in Cents)" disabled
                      value={baseArea.find(a => String(a.location_id) === String(item.location_id) && a.sub_location === item.sub_location && a.area_management_id === 3)?.available_area || ""}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      label="Land Requirement (in Cents)"
                      name="area_in_sqft"
                      value={item.area_in_sqft || ""}
                      onChange={(e) => handleAreaRequirementChange(e, index)}
                      disabled={!item.sub_location}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      label="Lease Years"
                      name="lease_year"
                      value={item.lease_year || ""}
                      onChange={(e) => handleInputChange(e, index)}
                      disabled={!item.sub_location}
                      required
                    />
                  </div>
                </>
              )}

              <div className="col-md-6">
                <CommonForm fieldType="multiline" label="Investment Model" name="investment_model" value={item.investment_model || ""} onChange={(e) => handleInputChange(e, index)} disabled={!item.category} required />
              </div>
              <div className="col-md-6">
                <CommonForm fieldType="multiline" label="Management Plan" name="management_plan" value={item.management_plan || ""} onChange={(e) => handleInputChange(e, index)} disabled={!item.category} required />
              </div>
            </div>
          </div>
        );
      })}

      {formvalues.length < 3 && (
        <button type="button" className="btn btn-primary" onClick={handleAdd}>Next Preference</button>
      )}

      <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />
    </div>
  );
}



